var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5011 18.7512C5.89859 18.7512 2.16797 15.02 2.16797 10.4181C2.16797 5.81621 5.89922 2.08496 10.5011 2.08496C15.1036 2.08496 18.8342 5.81621 18.8342 10.4181C18.8286 15.0181 15.1011 18.7462 10.5017 18.7512H10.5011ZM10.5011 3.75121C6.81922 3.75121 3.83422 6.73621 3.83422 10.4181C3.83422 14.1 6.81922 17.085 10.5011 17.085C14.183 17.085 17.168 14.1 17.168 10.4181C17.1636 6.73809 14.1817 3.75559 10.5017 3.75121H10.5011ZM14.668 10.4181C14.668 9.95809 14.2948 9.58496 13.8348 9.58496H7.16797C6.70797 9.58496 6.33484 9.95809 6.33484 10.4181C6.33484 10.8781 6.70797 11.2512 7.16797 11.2512H13.8348C14.2948 11.2512 14.668 10.8781 14.668 10.4181Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMore);
export default __webpack_public_path__ + "static/media/view-more.00e3b06cc50a7a1e7f11bf46a1edc31b.svg";
export { ForwardRef as ReactComponent };